import { ModalOrNotificationList } from "./ModalOrNotificationList";

export class Modal
{
    static open(oModalDiv)
    {
        oModalDiv.dataset.isShown = true;
        ModalOrNotificationList.open();
        const body = document.querySelectorAll('.o-body')[0];
        body.classList.toggle('o-body--withOpenModal', true);
    }

    static close(oModalDiv = null)
    {
        if (oModalDiv !== null) {
            oModalDiv.dataset.isShown = false;
        }
        const body = document.querySelectorAll('.o-body')[0];
        body.classList.toggle('o-body--withOpenModal', Modal.#isAnyModalOpen());
        ModalOrNotificationList.close()
    }

    static #isAnyModalOpen()
    {
        const body = document.querySelectorAll('.o-body')[0];
        return !!([...body.querySelectorAll('.o-modal')].filter((e) => e.dataset.isShown === 'true').length);
    }

}
